import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { Services } from '@ibexfusion/core-utils';

@Component({
    selector: 'composition-wizard-screen',
    templateUrl: './composition-wizard-screen.component.html',
    styleUrls: ['./composition-wizard-screen.component.scss'],
    standalone: false
})
export class CompositionWizardScreenComponent implements OnInit {

  @Input() composition: Models.Composition;
  @Input() isCopy: boolean;
  @Input() organisations: any[];
  @Input() orgCustomers: any[];
  @Output() organisationSet: EventEmitter<string> = new EventEmitter();
  @Output() customerSet: EventEmitter<string> = new EventEmitter();

  public availableLanguages = [
    { key: 'de', title: 'German', checked: false, disabled: false }, { key: 'en', title: 'English', checked: false, disabled: false },
    { key: 'fr', title: 'French', checked: false, disabled: false }, { key: 'it', title: 'Italian', checked: false, disabled: false }
  ];

  constructor() {
  }

  ngOnInit() {
    if (!this.composition.screen) {
      this.composition.screen = new Models.CompositionScreen();
      this.composition.screen.populateFromJSON({ availableLanguages: null });
    }
    if (this.composition.screen.availableLanguages) {
      for (let i = 0; i < this.composition.screen.availableLanguages.length; i++) {
        const lang = this.composition.screen.availableLanguages[i];
        for (let j = 0; j < this.availableLanguages.length; j++) {
          if (this.availableLanguages[j].key === lang) {
            this.availableLanguages[j].checked = true;
          }
        }
      }
      if (this.composition.screen.disabledLanguages) {
        for (let i = 0; i < this.composition.screen.disabledLanguages.length; i++) {
          const lang = this.composition.screen.disabledLanguages[i];
          for (let j = 0; j < this.availableLanguages.length; j++) {
            if (this.availableLanguages[j].key === lang) {
              this.availableLanguages[j].disabled = true;
            }
          }
        }
      } else {
        this.composition.screen.disabledLanguages = [];
      }
    }

    if (!this.composition.address) {
      this.composition.address = new Models.CompositionAddress();
      this.composition.address.populateFromJSON({
        title: null, street: null, zip: null, city: null, phoneLabel: null, phone: null, fax: null, email: null, website: null, logo: null, background: null, favIcon: null,
        appTitle: null
      });
    }

    if (!this.composition.location) {
      this.composition.location = new Models.CompositionLocation();
      this.composition.location.populateFromJSON({ type: 'Point', coordinates: [] });
    }
  }

  public assignLanguages(): void {
    const languages = [];
    for (let i = 0; i < this.availableLanguages.length; i++) {
      if (this.availableLanguages[i].checked) {
        languages.push(this.availableLanguages[i].key);
      } else {
        this.availableLanguages[i].disabled = false;
      }
    }
    this.composition.screen.availableLanguages = languages;
    this.disableLanguages();
    if (languages.length === 0) {
      this.composition.screen.availableLanguages = null;
    }
  }

  public disableLanguages(): void {
    const activatedLanguages = [];
    for (let i = 0; i < this.availableLanguages.length; i++) {
      if (this.availableLanguages[i].checked && this.availableLanguages[i].disabled) {
        activatedLanguages.push(this.availableLanguages[i].key);
      }
    }
    this.composition.screen.disabledLanguages = activatedLanguages;
  }

  public setOrganisation(event: any) {
    this.organisationSet.emit(Services.HashIdService.unhashSingle(event.value));
  }

  public setCustomer(event: any) {
    this.customerSet.emit(event.value);
  }

}
